import React from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {useNavigate} from "react-router-dom";

import './PlayPickX.style.scss';
const PlayPickX = () => {
    const navigate = useNavigate();
    const { locale } = useIntl();

    return (
        <div className="PlayPickX">
            <div className="hero">
                <div className="content">
                    <div className='leftSide'>
                        <div className='leftSideContent'>
                            <div className={'title1'}><FormattedMessage
                                id={'landingPage.playPickX.title1'} values={{
                                bold: (chunks) => {
                                    const id = typeof chunks === 'string' ? chunks : JSON.stringify(chunks);
                                    return <span key={id} className="gold-gradient-text">{chunks}</span>;
                                }
                            }}/></div>
                            <div className={'subtitle'}>
                                <FormattedMessage id={'landingPage.playPickX.subtitle'} values={{
                                    bold: (chunks) => {
                                        const id = typeof chunks === 'string' ? chunks : JSON.stringify(chunks);
                                        return <span key={id} className="gold-gradient-text">{chunks}</span>;
                                    }
                                }}/>
                            </div>
                            <button className={'signUpButton'} onClick={() => {
                                navigate('/register')
                            }}>
                                <FormattedMessage id={'landingPage.playPickX.signUpNow'}/>
                            </button>
                        </div>
                    </div>
                    <div className={`rightSide tradefanNewestGameImage ${locale}`}></div>
                </div>
            </div>

        </div>
    );
}

export default PlayPickX;